const getDigits = str => {
    if (str) {
        const regex = /\d+/gm;
        const price = regex.exec(str?.replace(/\s/gm, ''));

        return parseInt(Array.isArray(price) ? price[0] : price);
    }

    return str;
};

export default getDigits;
